import { Component, inject, signal } from '@angular/core';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

@Component({
	selector: 'app-docx-viewer-dialog',
	templateUrl: './docx-viewer-dialog.component.html',
	standalone: false,
})
export class DocxViewerDialogComponent {
	drawerData = signal(inject(DRAWER_DATA));

	editDocx() {
		this.drawerData().onEdit();
	}
}
